import { render, staticRenderFns } from "./resumeBank.vue?vue&type=template&id=90b4eafc&scoped=true&"
import script from "./resumeBank.vue?vue&type=script&lang=js&"
export * from "./resumeBank.vue?vue&type=script&lang=js&"
import style0 from "./resumeBank.vue?vue&type=style&index=0&id=90b4eafc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b4eafc",
  null
  
)

export default component.exports